import * as React from "react";
const SvgFiRrTtyAnswer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tty-answer_svg__a)">
      <path
        fill="#062147"
        d="M20.656 14.856a3.1 3.1 0 0 0-4.281.006l-1.456 1.159c-3.309-1.458-5.589-3.733-6.947-6.932l1.165-1.464a3.1 3.1 0 0 0 .007-4.282S7.291.936 7.261.905C6.054-.302 4.091-.301 2.934.858l-1.15 1.004C.633 3.012 0 4.565 0 6.238 0 13.874 10.126 24 17.762 24a6.15 6.15 0 0 0 4.421-1.834l.911-1.049a3.1 3.1 0 0 0 0-4.378c-.031-.031-2.438-1.883-2.438-1.883m.976 4.897-.911 1.05c-.77.771-1.821 1.196-2.959 1.196C10.805 21.999 2 12.227 2 6.237c0-1.138.425-2.188 1.147-2.913l1.15-1.004a1.097 1.097 0 0 1 1.51-.039S7.649 4.676 7.68 4.706c.207.207.321.482.321.774s-.114.567-.321.774a471 471 0 0 0-1.635 2.044 1 1 0 0 0-.151.979c1.58 4.141 4.544 7.108 8.812 8.821.333.135.714.08.995-.146 0 0 2.018-1.607 2.044-1.635a1.097 1.097 0 0 1 1.549 0c.03.03 2.423 1.872 2.423 1.872.389.43.375 1.097-.085 1.561zM21 .999a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1m-4 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1m-4 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1m-4 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1m15 4a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1m-11 0a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tty-answer_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTtyAnswer;
